import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem, Message } from 'primeng/primeng';
import { Table } from 'primeng/components/table/table';
import { PositionService} from '../services/position.service';
import { UserService } from '../services/user.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-summary-infraction-report',
  templateUrl: './summary-infraction-report.component.html',
  styleUrls: ['./summary-infraction-report.component.css']
})
export class SummaryInfractionReportComponent implements OnInit {

  cols: any[];
  dateOptions: SelectItem[];
  dateOption: any;
  startDate: Date;
  endDate: Date;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  fileName:String;
  msgs: Message[];
  blockedDocument: boolean = false;
  summaryInfractions: any [];
  maxDays:number=10;

  constructor(private positionService:PositionService, private userService:UserService) { }

  ngOnInit() {
    this.cols = [
      { field: 'name', header: 'NOMBRE' },
      { field: 'overspeed', header: 'EXCESOS DE VELOCIDAD' },
      { field: 'hardAcceleration', header: 'ACELERACIONES BRUSCAS' },
      { field: 'hardBraking', header: 'FRENADOS BRUSCOS' },
      { field: 'leisure', header: 'OCIO' },
      { field: 'total', header: 'TOTAL'}
    ];
    this.dateOptions = [
      {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
      {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
      {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
      {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
    ];
    this.dateOption = 'T';
    this.changeDate();
  }

  changeDate(){
    this.disabledInitialDate = true;
    this.disabledFinalDate = true;
    if(this.dateOption == 'T'){
      this.startDate = new Date();
      this.endDate = new Date();
      this.startDate.setHours(0,0,0);
      this.endDate.setHours(23,59,59);
    }else if(this.dateOption == 'Y'){
      this.startDate = new Date();
      this.endDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 1);
      this.startDate.setHours(0,0,0);
      this.endDate.setDate(this.endDate.getDate() - 1);
      this.endDate.setHours(23,59,59);
    }else if(this.dateOption == '7'){
      this.startDate = new Date();
      this.endDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 6);
      this.startDate.setHours(0,0,0);
      this.endDate.setHours(23,59,59);
    }else{
      this.disabledInitialDate = false;
      this.disabledFinalDate = false;
    }
  }

  diferenciaEntreFechasEnDias(a:Date, b:Date):number{
    return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
  }

  buscar(){
    this.fileName="Resumen_de_Infracciones";
    if(this.diferenciaEntreFechasEnDias(this.startDate,this.endDate) > this.maxDays){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
      return;
    }
    if(this.startDate >= this.endDate){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
      return;
    }

    this.blockedDocument = true;
    this.positionService.getSummaryInfractions(this.startDate,this.endDate,this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      this.summaryInfractions = [...response.summaryInfractions];
      this.blockedDocument = false;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }

  exportXLS(){
    let records = [];
    this.summaryInfractions.forEach(item=>{
      let data = {};
      this.cols.forEach(col => {
        data[col.header] = item[col.field];
      });
      records.push(data);
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.fileName+".xlsx");
  }

}



// WEBPACK FOOTER //
// ./src/app/summary-infraction-report/summary-infraction-report.component.ts